<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-6">
            <a @click="openPage('/sales')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Sales Manager</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.sales_manager_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataSalesManager" :key="item.id" :value="item.id">{{item.fullname}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Sales</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.sales_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataSales" :key="item.id" :value="item.id">{{item.fullname}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'editCoach',
  data: function () {
    return {
      editData: {
        branch_id: null,
        sales_manager_id: null,
        sales_id: null
      },
      config: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d'
      },
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      dataBranch: [],
      dataSalesManager: [],
      dataSales: [],
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.put('crm/v1/sales_relation/'+(this.$route.query.id), this.editData).then(response => {
            this.$router.push('/salesMapping')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    changeBranch(event) {
      this.editData.sales_id = null
      this.editData.sales_manager_id = null
      let url = 'crm/v1/sales?sorting=fullname&sorting_type=asc&status=active&user_role_id=4'
      let url2 = 'crm/v1/sales?sorting=fullname&sorting_type=asc&status=active&user_role_id=3'
      if (event != null) {
        url += '&branch_id=' + event
        url2 += '&branch_id=' + event
      }
      axios.get(url).then(response => {
        this.dataSalesManager = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get(url2).then(response => {
        this.dataSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/sales_relation/'+ this.$route.query.id).then(response => {
        this.editData.branch_id = response.data.data.sales_manager.branch.id
        this.editData.sales_manager_id = response.data.data.sales_manager_id
        this.editData.sales_id = response.data.data.sales_id
        let url = 'crm/v1/sales?sorting=fullname&sorting_type=asc&status=active&user_role_id=4&branch_id=' + this.editData.branch_id
        let url2 = 'crm/v1/sales?sorting=fullname&sorting_type=asc&status=active&user_role_id=3&branch_id=' + this.editData.branch_id
        axios.get(url).then(response => {
          this.dataSalesManager = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
        axios.get(url2).then(response => {
          this.dataSales = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
